import Service from 'src/services/pos.service'
import { executeAction } from './global.actions'

export const actions = {
  GET_POS_METHOD_PAYMENT_CONFIGURATION: 'GET_POS_METHOD_PAYMENT_CONFIGURATION',
  SAVE_POS_METHOD_PAYMENT_CONFIGURATION: 'SAVE_POS_METHOD_PAYMENT_CONFIGURATION',
}

export const getPOSMethodPaymentConfiguration = (posId: number) => dispatch => {
  const process = async () => ({
    payload: await Service.getPOSMethodPaymentConfiguration(posId),
  })
  dispatch(executeAction(actions.GET_POS_METHOD_PAYMENT_CONFIGURATION, process))
}

export const savePOSMethodPaymentConfiguration =
  (request: POSMethodPaymentConfiguration) => dispatch => {
    const process = async () => ({
      payload: await Service.savePOSMethodPaymentConfiguration(request),
    })
    dispatch(executeAction(actions.SAVE_POS_METHOD_PAYMENT_CONFIGURATION, process))
  }
